<template>
<div>
    <div class="row model-width product-details-layout">
        <div class="col-md-4 product-purchase-column">
            <div class="pt-12 pb-7 product-image-wrapper" v-if="selectedVariant">
                <div v-if="selectedVariant.formatted_images.default_image.length > 0" class="bg-img-height" :style="`background-image: url(${getBrandImageUrl(selectedVariant.formatted_images.default_image)})`"></div>
                <div v-else   class="bg-img-height" :style="`background-image: url('/images/no-image-500x500.jpg')`"></div>
            </div>
            <div class="pt-12 pb-7 product-image-wrapper" v-else>
                <div v-if="imagesExistance && defualtImageExistance && show_product_details" class="bg-img-height" :style="`background-image: url(${getBrandImageUrl(product.formatted_images.default_image)})`"></div>
                <div v-else-if="imagesExistance && defualtImageExistance && !show_product_details" class="bg-img-height" :style="`background-image: url(${getBrandImageUrl(product.formatted_images.default_image)})`"></div>
                <div v-else-if="(open_product_from_order && defualtImageExistance) && show_product_details" class="bg-img-height" :style="`background-image: url(${getBrandImageUrl(product.formatted_images.default_image)})`"></div>
                <div v-else-if="product.images"  class="bg-img-height" :style="`background-image: url(${getBrandImageUrl(product.images.default_image)})`"></div>
                <div v-else   class="bg-img-height" :style="`background-image: url(('/images/no-image-500x500.jpg')`"></div>
            </div>
            <div v-if="!product.is_from_bundle" class="purchase-controls">
                <template v-if="$store.state.brand_settings['allow_decimal_order_quantity'] == '1' ">
                    <input class="form-control" :id="product.id + '-quantity'" @change="handleInput(product)" type="number" v-if="!buttonSoldOut" :min="min" :step="step" :max="product.max_pur_qty ? product.max_pur_qty : ProductMaxQuantity" placeholder="Quantity" :disabled="$store.state.orderDetailModalOpen || quantityDisable" v-on:keyup.enter="addProductToCart(product)" v-model="quantityValue">
                </template>
                <template v-else>
                    <input class="form-control" onkeypress="return event.charCode >= 48 && event.charCode <= 57" :id="product.id + '-quantity'" @change="handleInput(product)" type="number" v-if="!buttonSoldOut" :min="min" :step="step" :max="product.max_pur_qty ? product.max_pur_qty : ProductMaxQuantity" placeholder="Quantity" :disabled="$store.state.orderDetailModalOpen || quantityDisable" v-on:keyup.enter="addProductToCart(product)" v-model="quantityValue">
                </template>
                <button type="button" :id="product.id + '-cartButton'" :class="btnClass" @click="addProductToCart(product)" v-if="!buttonSoldOut" :disabled="cartDisable || $store.state.orderDetailModalOpen">{{btnText}}</button>
                <button type="button"  v-else class="btn btn-secondary mt-5 form-control">{{$t('sold_out')}}</button>
            </div>

        </div>
        <div class="col-md-8 product-info-column">
            <div class="form-group row pt-10 product-title-row">
                <div class="col-md-12">
                    <span class="font-size-h1 font-weight-bolder product-title">
                     {{product.n}}
                    </span>
                </div>
            </div>

            <div v-if="product.description" class="separator my-5"></div>
            <div v-if="product.description" class="form-group form-group-xs row product-description">
                <div class="col-md-12 col-lg-12">
                    <label  class="font-weight-bolder font-size-h3">{{$t('description')}}:</label>
                    <span v-html="selectedVariant?.description ? selectedVariant.description : product.description" class="form-text custom-height"></span>
                </div>
            </div>
            <div class="separator my-5"></div>
            <div class="form-group form-group-xs row">
                <div class="col-md-6 col-lg-6" v-if="!($store.getters.role =='customer-contact' && $store.getters.brand.hide_sku_on_shop=='1')">
                    <label class="font-weight-bolder font-size-h5">{{$t('sku')}}</label>
                    <span class="form-text">{{product.sku}}</span>
                </div>
                <div class="col-md-6">
                    <label class="font-weight-bolder font-size-h5">{{$t('category')}}</label>
                    <span class="form-text">{{selectedVariant?.category_name ? selectedVariant.category_name : product.category_name}}</span>
                </div>
            </div>
            <div class="separator my-5" v-if="!product.hasVariants && !product.is_from_bundle"></div>
            <div v-if="!product.hasVariants && !product.is_from_bundle">
                <div class="form-group form-group-xs row">
                   <div v-if="product.min_pur_qty" class="col-md-6">
                       <label class="font-weight-bolder font-size-h5">{{$t('minimum_purchase_quantity')}}:</label>
                       <span  class="form-text">{{commaSeprator(product.min_pur_qty)}}</span>
                   </div>
                   <div class="col-md-6" v-if="product.max_pur_qty" >
                       <label class="font-weight-bolder font-size-h5">{{$t('maximum_purchase_quantity')}}:</label>
                       <span class="form-text">{{commaSeprator(product.max_pur_qty)}}</span>
                   </div>
                </div>
                <div class="separator my-5"></div>
                <div class="form-group form-group-xs row">
                     <div class="col-md-6" v-if="$store.getters.brand.show_retail_price_to_customers === '1' && show_product_details && $store.getters.brand.hide_price_shop_view=='0'">
                         <div  v-if="product.msrpDisplayName">
                          <label class="font-weight-bolder font-size-h5">{{product.msrpDisplayName}}:</label>
                          <span v-if="product.currency_symbol" class="form-text">{{product.currency_symbol}}{{commaSeprator(product.rp)}}</span>
                          <span v-else class="form-text">{{product.currency}}{{commaSeprator(product.rp)}}</span>
                         </div>
                         <div v-else >
                         <label class="font-weight-bolder font-size-h5">{{msrp}}:</label>
                          <span v-if="product.currency_symbol" class="form-text">{{product.currency_symbol}}{{commaSeprator(product.rp)}}</span>
                          <span v-else class="form-text">{{product.currency}}{{commaSeprator(product.rp)}}</span>
                         </div>
                     </div>
                    <div class="col-md-6" v-if="!product.uses_volume_price_tiers && $store.getters.brand.hide_price_shop_view=='0'">
                        <label class="font-weight-bolder font-size-h5">{{$t('wholesale')}}:</label>
                        <span v-if="product.dp" class="form-text">{{product.currency}}{{commaSeprator(product.dp)}}</span>
                        <span v-else  class="form-text">{{product.currency_symbol}}{{commaSeprator(product.price)}}</span>
                    </div>
                    <div v-else-if="product.hasOwnProperty('volume_tier_min_max') && $store.getters.brand.hide_price_shop_view=='0'" v-for="(min_max, index) in product.volume_tier_min_max" :key="index" class="col-md-6 vol-pricetier-container">
                        <label class="font-weight-bolder font-size-h5" >{{commaSeprator(min_max.min)}} - {{commaSeprator(min_max.max)}} Units:</label>
                        <span  class="form-text">{{product.currency_symbol}}{{commaSeprator(min_max.price)}}</span>
                    </div>
                    <div v-else-if="$store.getters.brand.hide_price_shop_view=='0'" class="col-md-6">
                        <label class="font-weight-bolder font-size-h5">{{$t('wholesale')}}:</label>
                        <span v-if="open_product_from_order" class="form-text">{{product.currency}}{{commaSeprator(product.dp)}}</span>
                        <span v-else class="form-text">{{product.currency_symbol}}{{commaSeprator(product.price)}}</span>
                    </div>
                </div>
                <div class="separator my-5" v-if="product.settings.show_inventory"></div>
                <div class="form-group form-group-xs row" v-if="product.settings.show_inventory">
                    <div  class="col-md-6">
                        <label class="font-weight-bolder font-size-h5">{{$t('total_inventory')}}:</label>
                        <span class="form-text" v-if="product.total_inventory_level ">{{commaSeprator(product.total_inventory_level)}}</span>
                    </div>
                   <div class="col-md-6">
                        <label class="font-weight-bolder font-size-h5">{{$t('available_inventory')}}:</label>
                        <span class="form-text">{{commaSeprator(product.inventory)}}</span>
                    </div>
                </div>
           </div>
           <div v-else>
                <div class="separator my-5" v-if="!product.is_from_bundle"></div>
                <div class="form-group form-group-xs row" v-if="!product.is_from_bundle">
                    <div class="col-md-6" v-if="product.hasVariants">
                        <label class="font-weight-bolder font-size-h5 pt-3">
                           {{$t('select_variant')}}
                        </label>
                    </div>
                    <div class="col-md-6 mobile-select">
                        <select class="form-control" :id="'var_' + product.id" :name="'var_' + product.id" v-model="selectVariantModel"  @change="updateVariant($event)">
                            <button type="button" class="variant-select-button">
                                <selectedcontent class="variant-selected-content"></selectedcontent>
                            </button>
                            <option disabled :data-id="product.id" value="">
                                {{$t('select_variant')}}
                            </option>
                            <option v-for="(varProduct, index) in product.variants" :key="index" v-bind:value="varProduct">
                            <!-- <option v-for="varProduct in product.variants" :key="varProduct.id" :value="varProduct"> -->
                             <!-- Implement the STore setting hide price in shop view  -->
                             <div v-if="$store.getters.brand.hide_price_shop_view=='0'">
                                <h2 v-if="!varProduct.uses_volume_price_tiers">{{varProduct.name}} -- {{varProduct.currency_symbol}}{{ commaSeprator(varProduct.price) }}</h2>
                                <h2 v-else-if="varProduct.uses_volume_price_tiers && varProduct.hasOwnProperty('price')">{{varProduct.name}} -- {{varProduct.currency_symbol}}{{ commaSeprator(varProduct.price)}}</h2>
                                <h2 v-else>{{varProduct.name}} -- {{varProduct.currency_symbol}}{{ commaSeprator(varProduct.low_price)}} - {{varProduct.currency_symbol}}{{ commaSeprator(varProduct.high_price)}}</h2>
                             </div>  
                             <div v-else>
                                <h2 v-if="!varProduct.uses_volume_price_tiers">{{varProduct.name}}</h2>
                                <h2 v-else-if="varProduct.uses_volume_price_tiers && varProduct.hasOwnProperty('price')">{{varProduct.name}}</h2>
                                <h2 v-else>{{varProduct.name}}</h2>
                             </div> 
                            </option>
                        </select>
                    </div>
                </div>
                <div class="separator my-5" v-show="selectedVariant && (product.settings.show_inventory && product.brand_inventory_level)"></div>
                <div class="form-group form-group-xs row" v-show="selectedVariant">
                    <div v-if="product.settings.show_inventory && product.brand_inventory_level" class="col-md-6">
                            <label class="font-weight-bolder font-size-h5">{{$t('total_inventory')}}:</label>
                            <span class="form-text">{{commaSeprator(product.total_inventory_level)}}</span>
                        </div>
                    <div v-if="product.settings.show_inventory && product.brand_inventory_level" class="col-md-6">
                        <label class="font-weight-bolder font-size-h5">{{$t('available_inventory')}}:</label>
                        <span class="form-text">{{commaSeprator(product.inventory)}}</span>
                    </div>
                </div>
           </div>
            
            <div class="separator my-5" v-show="selectedVariant.rp || selectedVariant.price"></div>
            <div class="form-group form-group-xs row" v-show="selectedVariant">
                <div class="col-md-6 col-lg-6" v-if="$store.getters.brand.show_retail_price_to_customers === '1' && $store.getters.brand.hide_price_shop_view=='0'">
                    <label class="font-weight-bolder font-size-h5">{{$t('msrp')}}</label>
                    <span class="form-text">{{selectedVariant.currency_symbol}}{{commaSeprator(selectedVariant.rp)}}</span>
                </div>
                <div class="col-md-6 col-lg-6" v-if="$store.getters.brand.hide_price_shop_view=='0' && selectedVariant.price">
                    <label class="font-weight-bolder font-size-h5">{{$t('wholesale')}}</label>
                    <span class="form-text">{{selectedVariant.currency_symbol}}{{commaSeprator(selectedVariant.price)}}</span>
                </div>
            </div>
           <div class="separator my-5" v-if="product?.custom_product_fields?.length>0"></div>
            <template v-if="product?.custom_product_fields?.length>0">
              <label class="font-weight-bolder font-size-h5 product-meta-heading">{{$t('Product Meta Fields')}}</label>
                <div class="row form-group form-group-xs">
                    <template v-for="product_meta_field in product.custom_product_fields" :key="product_meta_field">
                    <div class="col-md-6 product-meta-field" v-if="product_meta_field.product_meta_fields && product_meta_field.product_meta_fields.customer_visible == 1 && product_meta_field.value">
                        <label class="font-weight-bolder font-size-h5">{{ product_meta_field.product_meta_fields.title }}</label>
                        <span class="form-text">{{ product_meta_field.value }}</span>
                    </div>
                    </template>
                </div>
            </template>
            <div class="separator my-5"  v-show="product.upc || product.units_per_pack"></div>
            <div class="form-group form-group-xs row">  
                <div class="col-md-6" v-if="product.upc">
                    <label class="font-weight-bolder font-size-h5">{{$t('upc')}}</label>
                    <span  class="form-text">{{product.upc}}</span>
                </div>
                <div class="col-md-6" v-if="product.units_per_pack">
                    <label class="font-weight-bolder font-size-h5">{{$t('units_per_pack')}}</label>
                    <span  class="form-text">{{commaSeprator(product.units_per_pack)}}</span>
                </div>
            </div>    
            <div v-if="product.vendor_name || product.weight" class="separator my-5"></div>  
            <div class="form-group form-group-xs row">        
                <div v-if="product.vendor_name" class="col-md-6">
                    <label class="font-weight-bolder font-size-h5">{{$t('vendor')}}</label>
                    <span  class="form-text">{{product.vendor_name}}</span>
                </div>
                <div class="col-md-6" v-if="product.weight">
                    <label class="font-weight-bolder font-size-h5">{{$t('shipping_weight')}}:</label>
                    <span class="form-text">{{commaSeprator(product.weight)}} {{product.brand_weight_unit }}</span>
                </div>
                 <div class="col-md-6" v-if="selectedVariant.weight">
                    <label class="font-weight-bolder font-size-h5">{{$t('shipping_weight')}}:</label>
                    <span class="form-text">{{commaSeprator(selectedVariant.weight)}} {{selectedVariant.brand_weight_unit }}</span>
                </div>
            </div>
       </div>
    </div>
</div>
</template>
<script setup>
import ShopAPIService from '@/js/api/store/shop';
import {ref, defineProps, watch, watchEffect, computed, onMounted, onBeforeUnmount} from 'vue';
import { useI18n } from 'vue-i18n';
import eventBus from '@/js/utils/eventBus';
import { useStore } from 'vuex';
import {toast} from "vue3-toastify";
import 'vue3-toastify/dist/index.css';
import { getBrandImageUrl } from '@/js/utils/common.js';

const quantityValue = ref(0);
const buttonSoldOut = ref('');
const cartDisable = ref(false);
const min = ref(1);
const step = ref(1);
const quantityDisable = ref(false);
const btnClass = ref('btn btn-success form-control mt-5');
const { t } = useI18n();
const btnText = ref(t('add_to_cart'));
const enableVariantPrice = ref(false);
const productPrice = ref(0);
const show_inventory = ref(0);
const qty = ref(0);
const variant_inventory_level = ref(0);
const ProductMaxQuantity = ref(999999);
// const selectVariantModel = ref('');
const emit = defineEmits(['update:selectedVariant']);
const APIURL = import.meta.env.VITE_API_URL;
const store = useStore();

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  settings: {
    type: Object,
    required: false,
  },
  show_product_details: {
    type: Boolean,
    required: true,
  },
  open_product_from_order: {
    type: Boolean,
    required: false,
  },
  selectedVariant: {
    type: [String, Object],
    required: false,
  },
  msrp: {
    type: String,
    required: false,
  },
});

watchEffect(() => {
  if (props.product.hasVariants && props.selectedVariant) {
    cartDisable.value = false;
    quantityDisable.value = false;
  } else {
    cartDisable.value = true;
    quantityDisable.value = true;
  }
});

watch(() => props.product.id, () => {
  emit('update:selectedVariant', '');
});

const checkMinPurchaseQty = (product) => {
    if (props.settings.min_qty_multiples == '1') {
        setAttributesQuantity(false, product.min_pur_qty, product.min_pur_qty, product.min_pur_qty);
    } else {
        setAttributesQuantity(false, 1, 1, product.min_pur_qty);
    }
};
watch(() => {
  checkMinPurchaseQty(props.product);
});

const handleInput = (product) => {
    if(quantityValue.value == product.max_pur_qty){
        toast.warning("This is the Maximum purchase quantity for this product");//
        return;
    }
    if(store.state.brand_settings['sell_soldout_products'] == "0" && quantityValue.value > product.inventory && product.ti != 0){
        toast.error(`${product.sku} has no more quantity to be added`);//
        quantityValue.value = product.inventory
        return;
    }
    if (store.state.brand['allow_multiple_of_minimum_purchase_quantity'] == "1" && (quantityValue.value % product.min_pur_qty !== 0)){
        toast.error(`Quantity must be a multiple of Minimum Purchase Quantity (${product.min_pur_qty}).`);//
    }
};

const updateVariant = () => {
    props.product.total_inventory_level=props.selectedVariant.total_inventory_level;
    props.product.inventory=props.selectedVariant.inventory;
    var productId = props.product.id;
    var minQuantity = props.selectedVariant.min_pur_qty;
    minQuantity = (!minQuantity) ? 1 : minQuantity;
    // this.enableVariantPrice = true;
    checkPriceTier(props.selectedVariant);
    checkMinPurchaseQty(props.selectedVariant);
    checkProductSoldOut(props.selectedVariant);
    // this.productPrice = this.selectedVariant;
};
const checkPriceTier = (product) => {
    if(!product.uses_volume_price_tiers){
        productPrice.value = product.price;
    }
    if(product.uses_volume_price_tiers && product.hasOwnProperty("low_price") && product.hasOwnProperty("high_price")){
        productPrice.value =  product.low_price +'-'+  product.high_price;
    }
    else if(product.uses_volume_price_tiers && product.hasOwnProperty("price")){
        productPrice.value = product.price;
    }
};

const checkProductSoldOut = (product) => {
    // comment this code we dont need to swap the  value of product sold out 
    // this.buttonSoldOut = (product.so) ? false : true;
    buttonSoldOut.value = product.so;
};           

const selectVariantModel = computed({
  get: () => props.selectedVariant,
  set: (value) => emit('update:selectedVariant', value)
});

// Check if any product images exist
const imagesExistance = computed(() => {
  return  props.product.formatted_images ? true : false;
});

const defualtImageExistance = computed(() => {
    return props.product.formatted_images?.default_image ? true : false;
});


onMounted(() => {
  console.log('hello from product-details 277');

  eventBus.on('Product::variantDetails', (product_details, product) => {
    if (product_details) {
      checkMinPurchaseQty(props.product);
      checkProductSoldOut(props.product);
      disableCartButton(props.product);
      enableVariantPrice.value = !product.hasVariants;
    }
    checkPriceTier(product);
  });
  if (props.show_product_details) {
    checkMinPurchaseQty(props.product);
    checkProductSoldOut(props.product);
    disableCartButton(props.product);
    enableVariantPrice.value = !props.product.hasVariants;
  }
  checkPriceTier(props.product);
});

function setAttributesQuantity(quantityDisableValue, minValue, stepValue, value) {
    quantityDisable.value = quantityDisableValue;
    min.value = minValue;
    step.value = stepValue;
    quantityValue.value = value;
};
function setCartButton(newClass, newText, isDisabled) {
    btnClass.value = newClass;
    btnText.value = newText;
    cartDisable.value = isDisabled;
};
function disableCartButton(product) {
  if (product.hasVariants && props.selectedVariant === '') {
    cartDisable.value = true;
    quantityDisable.value = true;
  } else {
    cartDisable.value = false;
    quantityDisable.value = false;
  }
};

onBeforeUnmount(() => {
  eventBus.off('Product::variantDetails');
}); 
        
const filterInt = (value) => {
    if(/^(\-|\+)?([0-9]+|Infinity)$/.test(value))
        return Number(value);
    return NaN;
};
const filterFloat = (value) => {
    if(/^\d+(\.\d{1,2})?$/.test(value))
        return Number(value);
    return NaN;
};   
        
const addProductToCart = (product) => {
    if(store.state.brand.restrict_single_category_order == 1) {
        const productObj = product.hasVariants ? props.selectedVariant : product;
        const cartProducts = store.state.cartProducts;
        const categoryId = product.cat_id ?? product.category?.id;
        const hasDifferentCategoryProduct = cartProducts.some(cartProduct => 
        cartProduct.category_id !== categoryId 
        );
        if (hasDifferentCategoryProduct) {
            Swal.fire({
                icon: "error",
                title: "Oops!",
                text: "You cannot add products from different categories at the same time",
            });
            return;
        }
    }
    // if you want to restrict single product of each category then uncomment this code
    // if(store.state.brand.restrict_single_category_order == 1) {
    //     const productObj = product.hasVariants ? props.selectedVariant : product;
    //     const cartProducts = store.state.cartProducts;
    //     const categoryId = product.cat_id ?? product.category?.id;
    //     const hasSameCategoryProduct = cartProducts.some(cartProduct => 
    //         cartProduct.category_id == categoryId && 
    //         cartProduct.cartProduct_id != productObj.id &&
    //         cartProduct?.category_name?.toLowerCase() != "uncategorized"
    //     );
    //     if (hasSameCategoryProduct) {
    //         Swal.fire({
    //             icon: "error",
    //             title: "Oops!",
    //             text: "You cannot add products from the same category more than once.",
    //         });
    //         return;
    //     }
    // }
//Maximum purchase Quantity does not greather than 6 digit  
if(quantityValue.value>ProductMaxQuantity.value){
    toast.error("This Maximum purchase quantity for this product is 999999");
}
else{
    let inputQuantity = quantityValue.value;
    let productId = product.id;
    setCartButton('btn btn-brand form-control mt-5', t('adding'), true);
    // TODO when parent fucntion hits api request on its result set button property to Add to cart
    if (product.hasVariants) {
        productId = props.selectedVariant.id;
        if(!productId){
            toast.warning(`Select a Variant`);
            setCartButton('btn btn-danger form-control', t('error'), true);
            setTimeout(()=>{
            setCartButton('btn btn-success form-control', t('add_to_cart'), false);
            },1000);
            return;
        }
        if(store.state.brand_settings['use_min_purchase_quantity'] == 1) {
            if(inputQuantity < props.selectedVariant?.min_purchase_quantity){
                toast.warning(`Quantity should not be less than (${props.selectedVariant.min_purchase_quantity}) .`);//
                setCartButton('btn btn-danger form-control', t('error'), true);
                setTimeout(() => {
                setCartButton('btn btn-success form-control', t('add_to_cart'), false);
                }, 1000);
                return;
            }
        }
        else {
            if(inputQuantity < 0.1){
                toast.warning(`Quantity should not be less than (${props.selectedVariant.min_purchase_quantity}) .`);
                setCartButton('btn btn-danger form-control', t('error'), true);
                setTimeout(() => {
                setCartButton('btn btn-success form-control', t('add_to_cart'), false);
                }, 1000);
                return;
            }
        }
    }
    if(store.state.brand_settings['use_min_purchase_quantity'] == 1) {
        if(inputQuantity < product.min_pur_qty){
            toast.warning(`Quantity should not be less than (${product.min_pur_qty}) .`);
            setCartButton('btn btn-danger form-control', t('error'), true);
            setTimeout(() => {
            setCartButton('btn btn-success form-control', t('add_to_cart'), false);
            }, 1000);
            return;
        }
    }
    else {
        if(inputQuantity < 0.1){
            toast.warning(`Quantity should not be less than (${product.min_pur_qty}) .`);
            setCartButton('btn btn-danger form-control', t('error'), true);
            setTimeout(() => {
            setCartButton('btn btn-success form-control', t('add_to_cart'), false);
            }, 1000);
            return;
        }
    }
    if (product.settings.decimelOrderAllow == 0) {
        var quantity = filterInt(inputQuantity);
        if (!Number.isInteger(quantity) || quantity < 1) {
            toast.warning(`Quantity must be a number greater than zero.`);
            setCartButton('btn btn-danger form-control', t('error'), true);
            setTimeout(() => {
            setCartButton('btn btn-success form-control', t('add_to_cart'), false);
            }, 1000);
            return;
        }
    } else {
        var quantity = filterFloat(inputQuantity);
        if (isNaN(quantity) || quantity < 0.1) {
            toast.warning(`Quantity must be a postive number greater than zero`);
            setCartButton('btn btn-danger form-control', t('error'), true);
            setTimeout(() => {
            setCartButton('btn btn-success form-control', t('add_to_cart'), false);
            }, 1000);
            return;
        }
    }
    if (store.state.brand['allow_multiple_of_minimum_purchase_quantity'] == "1" && (quantityValue.value % product.min_pur_qty !== 0)){
        toast.error(`Quantity must be a multiple of Minimum Purchase Quantity (${product.min_pur_qty}).`);
        setCartButton('btn btn-danger form-control', t('error'), true);
        setTimeout(() => {
        setCartButton('btn btn-success form-control', t('add_to_cart'), false);
        }, 1000);
        return;
    }
    store.commit('SHOW_LOADER',true)
    ShopAPIService.addToCart({
        quantity: quantity,
        productId: productId
    }).then((response) => {
        store.commit('SHOW_LOADER',false)
        if(response.data.hasOwnProperty("success")){
            eventBus.emit('refreshCart');
            toast.success(`${response.data.success}`);//
            setCartButton('btn btn-success form-control mt-5', t('success'), true);
            setTimeout(()=>{
            setCartButton('btn btn-success form-control mt-5', t('add_to_cart'), false);
            },1000);
        }
        else if(response.data.hasOwnProperty("error")){
            toast.error(`${response.data.error}`);//
            setCartButton('btn btn-danger form-control mt-5', t('error'), true);
            setTimeout(()=>{
            setCartButton('btn btn-success form-control mt-5', t('add_to_cart'), false);
            },1000);
        }
    }).catch((error) => {
        store.commit('SHOW_LOADER',false)
        toast.error("Product not found");//
        setCartButton('btn btn-danger form-control', t('error'), true);
        setTimeout(()=>{
        setCartButton('btn btn-success form-control', t('add_to_cart'), false);
        },1000);
    });
    }
}

</script>
<style scoped>
.custom-height {

  max-height: 350px;
  overflow: auto;
}
.vol-pricetier-container {
    padding-bottom: 10px;
}
.bg-img-height {
    height: 250px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    /*border-radius: 10px 10px 0 0;*/
}
.separator {
    border-bottom:1px solid #EBEDF3;
}
@media (max-width: 600px) {
    .mobile-select {
        --select-right-edge: 0px;
        width: 100%;
        min-width: 0;
        position: relative;
        box-sizing: border-box;
        padding-right: 0;
        padding-left: 0;
    }
    .mobile-select::after {
        content: "";
        position: absolute;
        z-index: 2;
        top: 1px;
        right: calc(var(--select-right-edge) + 1px);
        bottom: 1px;
        width: 28px;
        background-color: #fff;
        pointer-events: none;
    }
    .mobile-select::before {
        content: "";
        position: absolute;
        z-index: 3;
        top: 50%;
        right: calc(var(--select-right-edge) + 9px);
        border: 4px solid transparent;
        border-top-color: #6c757d;
        transform: translateY(-25%);
        pointer-events: none;
    }
    .mobile-select select {
        width: 100%;
        min-width: 0;
        max-width: 100%;
        margin-right: 0 !important;
        padding-right: 32px !important;
        -webkit-appearance: none;
        appearance: none;
        background-color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    @supports (appearance: base-select) {
        .mobile-select select,
        .mobile-select select::picker(select) {
            appearance: base-select;
        }
        .mobile-select select::picker-icon {
            display: none;
        }
        .mobile-select select::picker(select) {
            inline-size: anchor-size(width);
            min-inline-size: anchor-size(width);
            max-inline-size: anchor-size(width);
            box-sizing: border-box;
        }
        .mobile-select .variant-select-button {
            display: flex;
            align-items: center;
            width: 100%;
            min-width: 0;
            overflow: hidden;
            border: 0;
            padding: 0;
            background: transparent;
            color: inherit;
            font: inherit;
            font-weight: 400;
            text-align: left;
        }
        .mobile-select .variant-selected-content,
        .mobile-select .variant-selected-content * {
            display: block;
            width: 100%;
            min-width: 0;
            margin: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: inherit !important;
            font-weight: 400 !important;
            line-height: inherit;
        }
        .mobile-select select option,
        .mobile-select select option * {
            max-width: 100%;
            margin: 0;
            white-space: normal;
            overflow-wrap: anywhere;
            font-size: inherit !important;
            font-weight: 400 !important;
            line-height: 1.25;
        }
    }
}
@media (max-width: 600px){
    .model-width {
        width: 100%;
        margin-right: 0;
        margin-left: 0;
    }
    .product-purchase-column,
    .product-info-column {
        width: 100%;
        max-width: 100%;
        padding-right: 0;
        padding-left: 0;
    }
    .product-image-wrapper {
        display: flex;
        justify-content: center;
        padding-top: 2rem !important;
        padding-bottom: 2rem !important;
    }
    .bg-img-height {
        width: 100%;
        max-width: 280px;
        height: 220px;
        background-position: center center;
    }
    .purchase-controls {
        display: flex;
        align-items: stretch;
        gap: 0.75rem;
        width: 100%;
    }
    .purchase-controls > .form-control { min-width: 0; margin-top: 0 !important; }
    .purchase-controls > input.form-control { flex: 0 0 34%; width: 34%; }
    .purchase-controls > button.form-control { flex: 1 1 auto; width: auto; }
    .product-title-row { padding-top: 2rem !important; margin-bottom: 0; }
    .product-title-row > div,
    .product-description > div { padding-right: 0; padding-left: 0; }
    .product-title {
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        overflow-wrap: anywhere;
    }
    .product-description { width: 100%; margin-right: 0; margin-left: 0; }
    .product-description .custom-height {
        width: 100%;
        max-height: none;
        overflow-x: hidden;
        overflow-y: visible;
        overflow-wrap: anywhere;
    }
    .product-info-column .form-group-xs.row {
        width: 100%;
        margin-right: 0;
        margin-left: 0;
    }
    .product-info-column .form-group-xs:not(.product-description) > [class*="col-"] {
        display: flex;
        align-items: baseline;
        flex-wrap: nowrap;
        gap: 0.4rem;
        width: 100%;
        max-width: 100%;
        padding-right: 0;
        padding-left: 0;
        margin-bottom: 0.65rem;
    }
    .product-info-column .form-group-xs:not(.product-description) label,
    .product-meta-field label {
        flex: 0 0 auto;
        margin-bottom: 0;
        white-space: nowrap;
    }
    .product-info-column .form-group-xs:not(.product-description) .form-text,
    .product-meta-field .form-text {
        display: inline;
        flex: 0 0 auto;
        min-width: 0;
        margin-top: 0;
        white-space: nowrap;
    }
    .product-meta-heading { display: block; margin-bottom: 0.75rem; }
    .product-meta-field {
        display: flex;
        align-items: baseline;
        flex-wrap: nowrap;
        gap: 0.4rem;
        width: 100%;
        max-width: 100%;
        padding-right: 0;
        padding-left: 0;
        margin-bottom: 0.65rem;
    }
}
.btn.btn-success {
     color: #ffffff;
     background-color: #1bac94;
     border-color: #1BC5BD;
     border-radius:0px;
}
 .btn.btn-success i {
     color: #ffffff;
}
 .btn.btn-success .svg-icon svg g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
     fill: #ffffff;
}
 .btn.btn-success .svg-icon svg:hover g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
}
 .btn.btn-success.dropdown-toggle:after {
     color: #ffffff;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled), .btn.btn-success:focus:not(.btn-text), .btn.btn-success.focus:not(.btn-text) {
     color: #ffffff;
     background-color: #0BB7AF;
     border-color: #0BB7AF;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled) i, .btn.btn-success:focus:not(.btn-text) i, .btn.btn-success.focus:not(.btn-text) i {
     color: #ffffff;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled) .svg-icon svg g [fill], .btn.btn-success:focus:not(.btn-text) .svg-icon svg g [fill], .btn.btn-success.focus:not(.btn-text) .svg-icon svg g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
     fill: #ffffff;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled) .svg-icon svg:hover g [fill], .btn.btn-success:focus:not(.btn-text) .svg-icon svg:hover g [fill], .btn.btn-success.focus:not(.btn-text) .svg-icon svg:hover g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled).dropdown-toggle:after, .btn.btn-success:focus:not(.btn-text).dropdown-toggle:after, .btn.btn-success.focus:not(.btn-text).dropdown-toggle:after {
     color: #ffffff;
}
 .btn.btn-success.disabled, .btn.btn-success:disabled {
     color: #ffffff;
     background-color: #1BC5BD;
     border-color: #1BC5BD;
}
 .btn.btn-success.disabled i, .btn.btn-success:disabled i {
     color: #ffffff;
}
 .btn.btn-success.disabled .svg-icon svg g [fill], .btn.btn-success:disabled .svg-icon svg g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
     fill: #ffffff;
}
 .btn.btn-success.disabled .svg-icon svg:hover g [fill], .btn.btn-success:disabled .svg-icon svg:hover g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
}
 .btn.btn-success.disabled.dropdown-toggle:after, .btn.btn-success:disabled.dropdown-toggle:after {
     color: #ffffff;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text), .btn.btn-success:not(:disabled):not(.disabled).active, .show > .btn.btn-success.dropdown-toggle, .show .btn.btn-success.btn-dropdown {
     color: #ffffff;
     background-color: #0BB7AF;
     border-color: #0BB7AF;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text) i, .btn.btn-success:not(:disabled):not(.disabled).active i, .show > .btn.btn-success.dropdown-toggle i, .show .btn.btn-success.btn-dropdown i {
     color: #ffffff;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text) .svg-icon svg g [fill], .btn.btn-success:not(:disabled):not(.disabled).active .svg-icon svg g [fill], .show > .btn.btn-success.dropdown-toggle .svg-icon svg g [fill], .show .btn.btn-success.btn-dropdown .svg-icon svg g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
     fill: #ffffff;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text) .svg-icon svg:hover g [fill], .btn.btn-success:not(:disabled):not(.disabled).active .svg-icon svg:hover g [fill], .show > .btn.btn-success.dropdown-toggle .svg-icon svg:hover g [fill], .show .btn.btn-success.btn-dropdown .svg-icon svg:hover g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text).dropdown-toggle:after, .btn.btn-success:not(:disabled):not(.disabled).active.dropdown-toggle:after, .show > .btn.btn-success.dropdown-toggle.dropdown-toggle:after, .show .btn.btn-success.btn-dropdown.dropdown-toggle:after {
     color: #ffffff;
}
</style>
